/**
 * Central place to read Vite env vars. Prefer this over `import.meta.env.*`
 * scattered across the app so we can validate + type once.
 */
export const env = {
  apiBaseUrl: (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? '/api/v1',
} as const;
